import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { EventStatisticsEntity, GetAdminEventStatisticsParamsType } from './types';

export const getAdminEventStatistics = actionsFactories.createGetOneActionsFactory<
  EntityType<EventStatisticsEntity>,
  GetAdminEventStatisticsParamsType
>()(
  'GET_ADMIN_EVENT_STATISTICS_REQUEST',
  'GET_ADMIN_EVENT_STATISTICS_SUCCESS',
  'GET_ADMIN_EVENT_STATISTICS_FAILURE',
  'GET_ADMIN_EVENT_STATISTICS_RESET',
);
